import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSignup } from '@context/SignupContext';
import { toast } from 'react-toastify';

const ProtectedVerifyRoute = ({ children }) => {
  const { termsAccepted, isLoading } = useSignup();
  const location = useLocation();

  useEffect(() => {
    if (!isLoading && !termsAccepted) {
      toast.info('회원가입 약관에 동의해야 본인 인증을 진행할 수 있습니다.');
    }
  }, [termsAccepted, isLoading]);

  if (isLoading) {
    return <div>로딩 중...</div>;
  }

  if (!termsAccepted) {
    return <Navigate to="/terms" replace state={{ from: location }} />;
  }

  return children;
};

export default ProtectedVerifyRoute;
